/**
 * This is a temporary hook added to provided a reactive currentRoute object while the vue-router library adopts the vue composition api
 */
import { Route } from 'vue-router'
import { Ref, ref } from 'vue'

/**
 * Exposes the current route as a `ref`
 * @example console.log(currentRoute.value!.params.spid)
 * @note The `!` can safely be used to denote that the object is not null.
 * @note The object is set after each route resolution and before a component's `setup()` function
 */
let currentRoute: Ref<Route | null> | null = null

export const useRoute = (): Ref<Route | null> => {
  if (currentRoute === null) {
    currentRoute = ref<Route | null>(null)
  }
  return currentRoute
}

export const routeState = (to: Route) => {

  useRoute().value = to

}
